import { ApiDashboardSettingsResponse } from '../../../api/core/models';
import { ClientBoardV2 } from '../model';

export function apiDashboardSettingsToPathwayGap(
  dashboardSetting: ApiDashboardSettingsResponse
): ClientBoardV2['boardSettings']['pathwayGap'] {
  return { summary: dashboardSetting?.pathwayGap ?? '' };
}
